type Props = {
  date: Date;
};

export function UpdatedAt({ date }: Props) {
  return (
    <p className="body2 text-text-grayscale-caption">
      Updated:{" "}
      <time
        dateTime={date.toISOString()}
        className="sub2"
      >
        {date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })}
      </time>
    </p>
  );
}
